import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./cartsidebar.css";

export default function CartSidebar({
  open,
  setOpen
}) {

  const [cart, setCart] = useState([]);

  const navigate = useNavigate();

  const user_id =
    localStorage.getItem("user_id");

  // ================= LOAD CART =================

  const loadCart = () => {

    if (!user_id) {

      setCart([]);

      return;
    }

   const storeName =
  localStorage.getItem("storeLocation") || "Apple 1";

console.log("SIDEBAR STORE:", storeName);

axios.get(
  `https://apple2.shopat1stop.com/api/cart/${user_id}/${encodeURIComponent(storeName)}`
)
.then((res) => {

  console.log("SIDEBAR DATA:", res.data);

  setCart(res.data || []);

})
.catch((err) => {

  console.log("SIDEBAR ERROR:", err);

  setCart([]);

});
     
  };

  // ================= LOAD WHEN OPEN =================

useEffect(() => {

  if (open) {
    loadCart();
  }

  const handleLocationChange = () => {
    loadCart();
  };

  window.addEventListener(
    "locationChanged",
    handleLocationChange
  );

  return () => {
    window.removeEventListener(
      "locationChanged",
      handleLocationChange
    );
  };

}, [open]);
  // ================= UPDATE QUANTITY =================

  const updateQty = async (
    id,
    qty
  ) => {

    if (qty < 1) return;

    try {

      await axios.put(
        `https://apple2.shopat1stop.com/api/cart/${id}`,
        {
          quantity: qty
        }
      );

      loadCart();

    } catch (err) {

      console.log(err);
    }
  };

  // ================= REMOVE ITEM =================

  const removeItem = async (id) => {

    try {

      await axios.delete(
        `https://apple2.shopat1stop.com/api/cart/${id}`
      );

      loadCart();

    } catch (err) {

      console.log(err);
    }
  };

  // ================= TOTAL =================

  const total =
    cart.reduce(
      (sum, item) =>
        sum +
        Number(item.price) *
        Number(item.quantity),
      0
    );

  return (
    <>

      {/* ================= OVERLAY ================= */}

      {open && (

        <div
          className="sidebar-overlay"
          onClick={() =>
            setOpen(false)
          }
        />

      )}

      {/* ================= SIDEBAR ================= */}

      <div
        className={`cart-sidebar ${
          open ? "open" : ""
        }`}
      >

        {/* ================= HEADER ================= */}

        <div className="sidebar-header">

          <h2>
            🛒 Your Cart
          </h2>

          <button
            onClick={() =>
              setOpen(false)
            }
          >
            ✖
          </button>

        </div>

        {/* ================= EMPTY CART ================= */}

        {cart.length === 0 ? (

          <div className="empty-cart">

            <h3>
              Cart is empty ❌
            </h3>

          </div>

        ) : (

          <>
            {/* ================= ITEMS ================= */}

            {cart.map((item) => (

              <div
                className="sidebar-item"
                key={item.id}
              >

                {/* IMAGE */}

                <img
                  src={`https://apple2.shopat1stop.com${item.image}`}
                  alt={item.name}
                />

                {/* INFO */}

                <div className="sidebar-info">

                  <h4>
                    {item.name}
                  </h4>

                  <p>
                    $
                    {item.price}
                  </p>

                  {/* QTY */}

                  <div className="qty-box">

                    <button
                      onClick={() =>
                        updateQty(
                          item.id,
                          item.quantity - 1
                        )
                      }
                    >
                      −
                    </button>

                    <span>
                      {item.quantity}
                    </span>

                    <button
                      onClick={() =>
                        updateQty(
                          item.id,
                          item.quantity + 1
                        )
                      }
                    >
                      +
                    </button>

                  </div>

                  {/* REMOVE */}

                  <button
                    className="remove-btn"
                    onClick={() =>
                      removeItem(item.id)
                    }
                  >
                    Remove
                  </button>

                </div>

              </div>

            ))}

            {/* ================= FOOTER ================= */}

            <div className="sidebar-footer">

              <h3>
                Total: $
                {total.toFixed(2)}
              </h3>

              <button
                className="checkout-btn"
                onClick={() => {

                  setOpen(false);

                  navigate("/checkout");

                }}
              >
                Proceed to Checkout
              </button>

            </div>
          </>
        )}

      </div>

    </>
  );
}